export function animateViewBox(start, end, duration, setter, onFinish) {
  const startTime = performance.now();

  function frame(now) {
    const t = Math.min(1, (now - startTime) / duration);

    // easeOutQuad (smooth deceleration)
    const eased = t * (2 - t);

    const current = {
      x: start.x + (end.x - start.x) * eased,
      y: start.y + (end.y - start.y) * eased,
      w: start.w + (end.w - start.w) * eased,
      h: start.h + (end.h - start.h) * eased,
    };

    // update camera immediately
    setter(current);

    if (t < 1) {
      requestAnimationFrame(frame);
    } else {
      // animation finished
      if (typeof onFinish === "function") {
        onFinish();
      }
    }
  }

  requestAnimationFrame(frame);
}
